import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { H2, Image, Link } from 'components/atoms';
import { Container, Section } from 'components/atoms/Page';
import { generateStars } from 'utils/formatting';
import { ReviewCard } from 'components/molecules/';
import { pageTypes } from 'config/pageTypes';
import trustpilotType from 'assets/images/psp/Review/Trustpilot_brandmark.svg';

import './PSPReviewSection.scss';
import { REVIEW_SECTION_COMMON_TITLE } from '../../../config/constants';

function formatReviewDate(dateStr) {
	if (!dateStr || typeof dateStr !== 'string') return dateStr;
	const [year, month, day] = dateStr.split('-');
	const date = new Date(year, month - 1, day);
	if (isNaN(date.getTime())) return dateStr;
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: '2-digit',
	});
}

export default function PSPReviewSection({ className, reviewsData, pageType }) {
	const { headerTitle, reviews } = reviewsData;
	const title = headerTitle || 'Rated 4.4 out of 5 stars by our customers on';
	const isSGP = pageType === pageTypes.SGP;
	return (
		<Section
			className={classnames(className, 'reviews-section')}
			id="reviews-section"
		>
			<Container>
				<div className="star-container">
					{generateStars(4.5, 20, 20, 'green')}
				</div>
				<span className="nowrap-logo">
					<H2
						color="black"
						size="megaMobile"
					>
						{isSGP
							? title
							: title.concat(REVIEW_SECTION_COMMON_TITLE)}
						{!headerTitle && (
							<span className="trust-pilot-logo">
								<Image
									src={trustpilotType}
									alt="trust-pilot-star"
								/>
							</span>
						)}
					</H2>
				</span>
				{reviews && (
					<div className="reviews-list">
						{reviews.map((card) => (
							<Link
								key={card.link}
								href={card.link}
								target="_blank"
								rel="noreferrer noopener"
							>
								<ReviewCard
									title={card.title}
									stars={card.stars}
									date={
										isSGP && card.date
											? formatReviewDate(card.date)
											: card.date
									}
									link={card.link}
									description={card.text}
									user={card.customerName}
									customerImage={card.customerImage}
								/>
							</Link>
						))}
					</div>
				)}
				<div className="reviews-footer">
					<Link
						tertiary
						underline
						priceBlue
						href="https://www.trustpilot.com/review/www.selfstorage.com"
						target="_blank"
					>
						See more reviews on TrustPilot
					</Link>
				</div>
			</Container>
		</Section>
	);
}

PSPReviewSection.propTypes = {
	reviewsData: PropTypes.shape({
		headerTitle: PropTypes.string.isRequired,
		reviews: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string.isRequired,
				title: PropTypes.string.isRequired,
				link: PropTypes.string,
				text: PropTypes.string,
				stars: PropTypes.number,
				date: PropTypes.string,
				customerName: PropTypes.string,
			}),
		),
	}),
	className: PropTypes.string,
	pageType: PropTypes.oneOf([pageTypes.SGP, pageTypes.PSP]),
};
